import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { VaultPage } from "@/features/vault/VaultPage";

const search = z.object({
  asset: z.string().regex(/^[a-z0-9][a-z0-9-]{0,59}$/).optional(),
  client: z.string().min(1).max(80).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/vault/")({
  validateSearch: search,
  component: () => <VaultPage search={Route.useSearch()} />,
});
